<div class="sell-as-container" [formGroup]="sellAsFormgroup">
        <div class="sell-as-table-container">
            <table class="full-width" >
                <!-- Calculated GM% -->
                <tr class="sell-as-row">
                    <td class="estimate-table-column width-203 bold-font flex-start">{{ 'SELL_AS_CAPITAL' | translate}} </td>
                    <td class="estimate-table-column width-110"></td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-95 sell-as-percent-labels">
                            <ng-container *ngIf="this.isMarkUpSelected; else sellAsCalculatedMULabel">
                                {{ 'CALCULATED_MU_PERCENT' | translate}}
                            </ng-container>
                            <ng-template #sellAsCalculatedMULabel>
                                {{ 'CALCULATED_GM_PERCENT' | translate}}
                            </ng-template>
                    </td>
                    <td class="estimate-table-column width-70" formGroupName="calculated">
                        <ng-container *ngIf="sellAsFormgroup.controls.sellAsPricingMode.value != solEstimatePricingMode.Line_Item; else laborTemplate">
                                <ng-container *ngIf="this.isMarkUpSelected; else notMarkUp">
                                    <mat-form-field class="no-padding-input" appearance="outline" class="mat-input-alignment width-70">
                                        <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="markUpPercentage" class="input-alignment" />
                                    </mat-form-field>
                                </ng-container>
                                <ng-template #notMarkUp>
                                    <mat-form-field class="no-padding-input" appearance="outline" class="mat-input-alignment width-70">
                                        <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="grossMarginPercentage" class="input-alignment" />
                                    </mat-form-field>
                                </ng-template>
                            </ng-container>
                            <ng-template #laborTemplate>
                                <ng-container *ngIf="this.isMarkUpSelected; else notMarkUp">
                                    {{ sellAsFormgroup.controls.calculated.controls.markUpPercentage.value | decimalPrecision }}%
                                </ng-container>
                                <ng-template #notMarkUp>
                                    {{ sellAsFormgroup.controls.calculated.controls.grossMarginPercentage.value | decimalPrecision }}%
                                </ng-template>
                            </ng-template>
                    </td>
                    <td class="estimate-table-column width-210">
                        <div class="toggle-triple-button-container">
                            <mat-button-toggle-group 
                                name="fontStyle" 
                                aria-label="Font Style" 
                                formControlName="sellAsPricingMode"
                                class="toggle-triple-button-group fixed-margin">
                                <mat-button-toggle [value]="solEstimatePricingMode.Fixed_Margin"
                                    class="toggle-triple-button">
                                    {{ solEstimatePricingMode.Fixed_Margin }} 
                                </mat-button-toggle>
                                <mat-button-toggle 
                                    [value]="solEstimatePricingMode.Line_Item"
                                    class="toggle-triple-button">
                                    {{ solEstimatePricingMode.Line_Item }}
                                </mat-button-toggle>
                                <mat-button-toggle 
                                    [value]="solEstimatePricingMode.Fixed_Price"
                                    [disabled]="isFixedPriceDisabled"
                                    class="toggle-triple-button"
                                    [matTooltip]="('SELL_AS_ZERO_SELL_PRICE_MESSAGE' | translate)"
                                    [matTooltipDisabled]="!isFixedPriceDisabled">
                                    {{ solEstimatePricingMode.Fixed_Price }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </td>
                    <td class="estimate-table-column width-110">
                        <ng-container *ngIf="sellAsFormgroup.controls.sellAsPricingMode.value != solEstimatePricingMode.Line_Item; else noLaborInputSellPrice">
                            <mat-form-field class="no-padding-input" appearance="outline" class="mat-input-alignment width-110">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig" inputmode="decimal"
                                    formControlName="sellAsSellPrice" 
                                    class="input-alignment" 
                                />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #noLaborInputSellPrice>
                            {{ sellAsFormgroup.controls.sellAsSellPrice.value | multilingualCurrency }}
                        </ng-template>
                    </td>
                </tr>
                <!-- Reported GM% -->
                <tr class="sell-as-row">
                    <td class="estimate-table-column width-203 flex-start"></td>
                    <td class="estimate-table-column width-110"></td>
                    <td class="estimate-table-column width-70">
                        
                    </td>
                    <td class="estimate-table-column width-95 sell-as-percent-labels bold-font reported-mu-gm-header">
                        @if (showMinimumMarginWarningIcon) {
                        <img
                            [src]="'assets/images/Warning.gif'"
                            alt="Warning"
                            class="minimum-margin-warning-icon"
                            [matTooltip]="minimumMarginTooltipMessage"
                        />
                        }
                        <span class="reported-mu-gm-text">
                            <ng-container *ngIf="this.isMarkUpSelected; else sellAsReportedMULabel">
                                {{ 'REPORTED_MU_PERCENT' | translate}}
                            </ng-container>
                            <ng-template #sellAsReportedMULabel>
                                {{ 'REPORTED_GM_PERCENT' | translate}}
                            </ng-template>
                        </span>
                    </td>
                    <td class="estimate-table-column width-70 bold-font">
                        <ng-container *ngIf="this.isMarkUpSelected; else notMarkUp">
                            {{ sellAsFormgroup.controls.reported.controls.markUpPercentage.value | decimalPrecision }}%
                        </ng-container>
                        <ng-template #notMarkUp>
                            {{ sellAsFormgroup.controls.reported.controls.grossMarginPercentage.value | decimalPrecision }}%
                        </ng-template>
                    </td>
                    <td class="sell-as-triple-button-label width-210" [ngSwitch]="sellAsFormgroup.controls.sellAsPricingMode.value">
                        <p *ngSwitchCase="solEstimatePricingMode.Fixed_Margin" class="text-center width-180">{{ 'FIXED_MARGIN' | translate}}</p>
                        <p *ngSwitchCase="solEstimatePricingMode.Line_Item" class="text-center width-180">{{ 'LINE_ITEM' | translate}}</p>
                        <p *ngSwitchCase="solEstimatePricingMode.Fixed_Price" class="text-center width-180">{{ 'FIXED_PRICE' | translate}}</p>
                    </td>
                    <td class="estimate-table-column width-110"></td>
                </tr>
            </table>
        </div>
    </div>